/**
 * Contract for the admin user list at `/admin/users`: the columns it sorts by,
 * the outcomes of giving and removing a role, and the message shown when an
 * action would leave the system without an admin. Client-safe.
 *
 * Aliases: admin user list sort, users table sort
 */

export const ADMIN_USER_SORTS = ["name", "joined"] as const;
export type AdminUserSort = (typeof ADMIN_USER_SORTS)[number];

/** Shown whenever removing a role or deleting an account would end the last Admin. */
export const LAST_ADMIN_MESSAGE =
  "This is the last admin. Give Admin to someone else first.";

/** A change someone else already made counts as done, not as an error. */
export type GrantRoleResult =
  | { readonly status: "granted" }
  | { readonly status: "already_has" }
  | { readonly status: "user_not_found" }
  | { readonly status: "permission_lost" };

export type RemoveRoleResult =
  | { readonly status: "removed" }
  | { readonly status: "already_removed" }
  | { readonly status: "user_not_found" }
  | { readonly status: "permission_lost" }
  | { readonly status: "own_admin" }
  | { readonly status: "last_admin" };
